var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileEditGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47914 3.36638H5.31791C4.0533 3.36638 3.421 3.36638 2.93798 3.61162C2.51311 3.82733 2.16767 4.17154 1.95119 4.5949C1.70508 5.0762 1.70508 5.70626 1.70508 6.96638V13.2664C1.70508 14.5265 1.70508 15.1566 1.95119 15.6379C2.16767 16.0612 2.51311 16.4054 2.93798 16.6211C3.421 16.8664 4.0533 16.8664 5.31791 16.8664H11.6404C12.905 16.8664 13.5373 16.8664 14.0203 16.6211C14.4452 16.4054 14.7906 16.0612 15.0071 15.6379C15.2532 15.1566 15.2532 14.5265 15.2532 13.2664V10.1164M6.2211 12.3664H7.48149C7.84968 12.3664 8.03378 12.3664 8.20702 12.3249C8.36062 12.2882 8.50746 12.2276 8.64215 12.1453C8.79406 12.0526 8.92424 11.9229 9.18459 11.6634L16.3822 4.49138C17.0058 3.87006 17.0058 2.8627 16.3822 2.24138C15.7587 1.62006 14.7477 1.62006 14.1242 2.24138L6.92655 9.41344C6.6662 9.67287 6.53602 9.80258 6.44293 9.95395C6.36039 10.0882 6.29957 10.2345 6.26269 10.3875C6.2211 10.5602 6.2211 10.7436 6.2211 11.1105V12.3664Z",
    stroke: "#38cb89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditGreenIcon);
export default __webpack_public_path__ + "static/media/profile-edit-green-icon.582ed40d4d038928eeb6cc0dfa36cde0.svg";
export { ForwardRef as ReactComponent };